import axios from "axios";
import { MyError } from "@/utils/auth";
import { notification } from "ant-design-vue";
import { getToken } from "@/utils/auth";
import env from "@/env";

// create an axios instance
const service = axios.create({
  baseURL: env("VUE_APP_BASE_API"),
  timeout: 1200000
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent

    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config.headers["Authorization"] = `Bearer ${getToken()}`;

    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;

    /*
    // if the custom status is not 200, it is judged as an error.
    if (res.status !== 200) {
      // return Promise.reject(new MyError(res.status || 500, res.mensaje || "Error"));
      console.error("error...");
      return;
    } else {
      return res;
    } */

    return res;
  },
  (error) => {
    // judge for http status
    // if(status === 422){store.dispath("snackbar/showError", {text})}

    if (error.response) {
      if (error.response.status == 404) {
        notification.error({ message: "No encontramos la ruta " });
      }

      return Promise.reject(
        new MyError(error.response.status, error.response.data[0] || error.response.message)
      );
      // console.log("error status=> ", error.response.status);
      // const [{ mensaje }] = error.response.data.errores;

      // console.log(mensaje);
    }
    // message.error("Tenemos problemas con el servidor, por favor inténtelo más tarde");
    return;
  }
);

const { get, post, put, patch, delete: destroy } = service;

export { get, post, put, patch, destroy };

export default service;
